'use client';
import styled, { css, keyframes } from 'styled-components';

const slideInFromRight = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`;

const slideInFromLeft = keyframes`
  from { transform: translateX(-100%); }
  to { transform: translateX(0); }
`;

const slideOutToLeft = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-100%); }
`;

const slideOutToRight = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(100%); }
`;

export const StyledFullBleedSliderHero = styled.div`
  position: relative;
  width: 100%;
`;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const SliderViewport = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  height: 620px;

  @media ${props => props.theme.laptop} {
    max-height: 960px;
    min-height: 640px;
    height: 100vh;
  }
`;

export const SlideWrapper = styled.div`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  & > section {
    height: 100%;
    min-height: 100% !important;
    max-height: 100%;
  }

  ${props =>
    props.$entering || props.$exiting
      ? css`
          position: absolute;
          inset: 0;
          z-index: ${props.$entering ? 2 : 1};
          animation: ${props.$entering
              ? props.$direction === 'next'
                ? slideInFromRight
                : slideInFromLeft
              : props.$direction === 'next'
              ? slideOutToLeft
              : slideOutToRight}
            ${props.$animation?.durationMs ?? 640}ms
            ${props.$animation?.easing ?? 'cubic-bezier(0.76, 0, 0.24, 1)'} both;
          will-change: transform;
        `
      : css`
          position: relative;
          z-index: 1;
        `}
`;

export const DotIndicators = styled.div`
  position: absolute;
  bottom: ${props => props.theme.spacing(4)};
  left: ${props => props.theme.spacing(8)};
  display: flex;
  gap: ${props => props.theme.spacing(2)};
  z-index: 4;

  @media ${props => props.theme.laptopL} {
    left: 7%;
  }
  @media (min-width: 1650px) {
    left: 10%;
  }
  @media (min-width: 2000px) {
    left: 20%;
  }
  @media ${props => props.theme.desktop} {
    left: 22%;
  }
`;

export const DotButton = styled.button`
  width: ${props => (props.$active ? '24px' : '6px')};
  height: 6px;
  padding: 0;
  border: none;
  border-radius: ${props => (props.$active ? '3px' : '50%')};
  cursor: pointer;
  background-color: ${props => props.theme.colors.text.lightest};
  opacity: ${props => (props.$active ? 1 : 0.4)};
  transition: opacity 150ms ease-in-out, width 300ms ease-in-out;

  &:focus-visible {
    outline: 2px solid ${props => props.theme.colors.text.lightest};
    outline-offset: 2px;
  }
`;

export const HeroStatsSection = styled.div`
  width: 100%;
  display: block;

  @media (min-width: 1200px) {
    display: none;
  }
`;
